var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import classnames from "classnames";
import * as d3 from "d3";
import * as faux from "react-faux-dom";
export class Arrow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const _a = this.props, { className, prefixCls, frontArrowColor, backArrowColor, laneArrow, leftTwig, rightTwig, alternative, arrowData } = _a, restProps = __rest(_a, ["className", "prefixCls", "frontArrowColor", "backArrowColor", "laneArrow", "leftTwig", "rightTwig", "alternative", "arrowData"]);
        let isAlternative = false;
        const wrapCls = classnames(prefixCls, className);
        const fdiv = faux.createElement("div");
        const svg = d3.select(fdiv).append("svg");
        svg.attr("width", "100%").attr("height", "100%").attr("viewBox", "0 0 100 100").attr("preserveAspectRatio", "none");
        const g = svg.append("g");
        const drawTwig = (twig, x) => {
            g.append("rect")
                .attr("x", x)
                .attr("y", Math.round((100 - twig.height) / 2))
                .attr("width", twig.width)
                .attr("height", twig.height)
                .attr("stroke", "none")
                .attr("fill", twig.color.value)
                .attr("fill-opacity", twig.color.opacity);
        };
        const drawArrowKid = (paint, color) => {
            let pathData = "";
            pathData = arrowData.get(paint);
            if (isAlternative && (paint === "TURN_LEFT" || paint === "TURN_RIGHT"))
                pathData = arrowData.get(`${paint}1`);
            // switch (paint) {
            //   case "UNKNOWN":
            //     pathData = ""
            //     break
            //   case "STRAIGHT":
            //     pathData = "M54.688,34.385V82.813H45.313V34.385H39.055L50,17.185l10.946,17.2H54.688Z"
            //     break
            //   case "SHARP_RIGHT":
            //     pathData =
            //       "M45.317,61.166V82.819h9.371l0-16.165a1.227,1.227,0,0,1,.7-1.09,1.513,1.513,0,0,1,1.621.334l7.706,7.527L59.72,78.4l19.973,4.423-4.438-19.9-4.448,4.432L58.567,55.338l0-.011a7.8,7.8,0,0,0-4.782-2.177,8.216,8.216,0,0,0-6.476,2.406A8.1,8.1,0,0,0,45.317,61.166Z"
            //     break
            //   case "RIGHT":
            //     pathData =
            //       "M54.688,82.813V64.156l0,0s-0.1-3.316.982-4.55a5.758,5.758,0,0,1,3.2-1.8H69.521V64.07l17.2-10.945L69.521,42.18v6.258H55.446A10.339,10.339,0,0,0,45.313,58.606V82.813h9.375Z"
            //     break
            //   case "FORWARD_RIGHT":
            //     pathData =
            //       "M54.685,82.813V58.6a9.361,9.361,0,0,1,2.429-6.253L70.637,38.818l4.511,4.511,4.423-19.9-19.9,4.423,4.638,4.638L50,46.793a16.937,16.937,0,0,0-4.691,11.8V82.813h9.373Z"
            //     break
            //   case "SHARP_LEFT":
            //     pathData =
            //       "M54.683,61.166V82.819H45.313l0-16.165a1.227,1.227,0,0,0-.7-1.09,1.513,1.513,0,0,0-1.621.334l-7.706,7.527L40.28,78.4,20.307,82.823l4.438-19.9,4.448,4.432,12.24-12.014,0-.011a7.8,7.8,0,0,1,4.782-2.177,8.216,8.216,0,0,1,6.476,2.406A8.1,8.1,0,0,1,54.683,61.166Z"
            //     break
            //   case "LEFT":
            //     pathData =
            //       "M45.313,82.813V64.156l0,0s0.1-3.316-.982-4.55a5.758,5.758,0,0,0-3.2-1.8H30.479V64.07l-17.2-10.945,17.2-10.946v6.258H44.554A10.339,10.339,0,0,1,54.688,58.606V82.813H45.313Z"
            //     break
            //   case "FORWARD_LEFT":
            //     pathData =
            //       "M45.315,82.813V58.6a9.361,9.361,0,0,0-2.429-6.253L29.363,38.818l-4.511,4.511-4.423-19.9,19.9,4.423-4.638,4.638L50,46.793a16.937,16.937,0,0,1,4.691,11.8V82.813H45.315Z"
            //     break
            //   case "TURN_RIGHT":
            //     if (isAlternative) {
            //       pathData =
            //         "M54.7,82.806V61.058A3.265,3.265,0,0,1,57.975,57.8h5.948A3.265,3.265,0,0,1,67.2,61.058l-0.009,2.994H60.93l10.946,17.2,10.945-17.2H76.563l0.02-5.458A10.3,10.3,0,0,0,66.406,48.448H55.469A10.391,10.391,0,0,0,45.312,58.594V82.806H54.7Z"
            //     } else {
            //       pathData =
            //         "M54.675,82.814L54.7,31.228c0-3.168,3.071-5.812,6.228-5.812s6.243,2.644,6.243,5.812l0.019,11.73H60.93l10.946,17.2,10.945-17.2H76.563l0.02-11s0.033-3.276-.116-4.055A13.349,13.349,0,0,0,63.4,17.193H58.452A13.256,13.256,0,0,0,45.569,27.411a19.487,19.487,0,0,0-.245,2.771L45.308,82.814h9.367Z"
            //     }
            //     break
            //   case "TURN_LEFT":
            //     if (isAlternative) {
            //       pathData =
            //         "M45.3,82.806V61.058A3.265,3.265,0,0,0,42.025,57.8H36.077A3.265,3.265,0,0,0,32.8,61.058l0.009,2.994h6.258l-10.946,17.2L17.18,64.052h6.258l-0.02-5.458A10.3,10.3,0,0,1,33.594,48.448H44.531A10.391,10.391,0,0,1,54.688,58.594V82.806H45.3Z"
            //     } else {
            //       pathData =
            //         "M45.325,82.814L45.3,31.228c0-3.168-3.071-5.812-6.228-5.812s-6.243,2.644-6.243,5.812l-0.019,11.73h6.258l-10.946,17.2L17.18,42.958h6.258l-0.02-11s-0.033-3.276.116-4.055A13.349,13.349,0,0,1,36.6,17.193h4.952A13.256,13.256,0,0,1,54.431,27.411a19.487,19.487,0,0,1,.245,2.771l0.016,52.632H45.325Z"
            //     }
            //     break
            //   default:
            //     pathData = paint
            //     break
            // }
            pathData !== "" &&
                pathData !== undefined &&
                g
                    .append("path")
                    .attr("d", pathData)
                    .attr("stroke", "none")
                    .attr("fill", color.value)
                    .attr("fill-opacity", color.opacity);
        };
        if (laneArrow !== undefined && laneArrow.length > 0) {
            laneArrow.reverse().forEach(e => {
                if (alternative === null || alternative === void 0 ? void 0 : alternative.some(i => i === e.type)) {
                    isAlternative = true;
                }
                drawArrowKid(e.type, e.isRecommend ? frontArrowColor : backArrowColor);
            });
        }
        if (leftTwig !== undefined) {
            drawTwig(leftTwig, 0);
        }
        if (rightTwig !== undefined) {
            drawTwig(rightTwig, 99);
        }
        return (<div className={wrapCls} {...restProps}>
        {fdiv.toReact()}
      </div>);
    }
}
Arrow.defaultProps = {
    prefixCls: "pm-arrow",
    backArrowColor: { value: "#000", opacity: "0.25" },
    frontArrowColor: { value: "#F5F6FF", opacity: "1" },
    alternative: ["STRAIGHT", "FORWARD_LEFT", "FORWARD_RIGHT"],
    arrowData: new Map([
        ["UNKNOWN", ""],
        ["STRAIGHT", "M54.688,34.385V82.813H45.313V34.385H39.055L50,17.185l10.946,17.2H54.688Z"],
        [
            "SHARP_RIGHT",
            "M45.317,61.166V82.819h9.371l0-16.165a1.227,1.227,0,0,1,.7-1.09,1.513,1.513,0,0,1,1.621.334l7.706,7.527L59.72,78.4l19.973,4.423-4.438-19.9-4.448,4.432L58.567,55.338l0-.011a7.8,7.8,0,0,0-4.782-2.177,8.216,8.216,0,0,0-6.476,2.406A8.1,8.1,0,0,0,45.317,61.166Z",
        ],
        [
            "RIGHT",
            "M54.688,82.813V64.156l0,0s-0.1-3.316.982-4.55a5.758,5.758,0,0,1,3.2-1.8H69.521V64.07l17.2-10.945L69.521,42.18v6.258H55.446A10.339,10.339,0,0,0,45.313,58.606V82.813h9.375Z",
        ],
        [
            "FORWARD_RIGHT",
            "M54.685,82.813V58.6a9.361,9.361,0,0,1,2.429-6.253L70.637,38.818l4.511,4.511,4.423-19.9-19.9,4.423,4.638,4.638L50,46.793a16.937,16.937,0,0,0-4.691,11.8V82.813h9.373Z",
        ],
        [
            "SHARP_LEFT",
            "M54.683,61.166V82.819H45.313l0-16.165a1.227,1.227,0,0,0-.7-1.09,1.513,1.513,0,0,0-1.621.334l-7.706,7.527L40.28,78.4,20.307,82.823l4.438-19.9,4.448,4.432,12.24-12.014,0-.011a7.8,7.8,0,0,1,4.782-2.177,8.216,8.216,0,0,1,6.476,2.406A8.1,8.1,0,0,1,54.683,61.166Z",
        ],
        [
            "LEFT",
            "M45.313,82.813V64.156l0,0s0.1-3.316-.982-4.55a5.758,5.758,0,0,0-3.2-1.8H30.479V64.07l-17.2-10.945,17.2-10.946v6.258H44.554A10.339,10.339,0,0,1,54.688,58.606V82.813H45.313Z",
        ],
        [
            "FORWARD_LEFT",
            "M45.315,82.813V58.6a9.361,9.361,0,0,0-2.429-6.253L29.363,38.818l-4.511,4.511-4.423-19.9,19.9,4.423-4.638,4.638L50,46.793a16.937,16.937,0,0,1,4.691,11.8V82.813H45.315Z",
        ],
        [
            "TURN_RIGHT1",
            "M54.7,82.806V61.058A3.265,3.265,0,0,1,57.975,57.8h5.948A3.265,3.265,0,0,1,67.2,61.058l-0.009,2.994H60.93l10.946,17.2,10.945-17.2H76.563l0.02-5.458A10.3,10.3,0,0,0,66.406,48.448H55.469A10.391,10.391,0,0,0,45.312,58.594V82.806H54.7Z",
        ],
        [
            "TURN_RIGHT",
            "M54.675,82.814L54.7,31.228c0-3.168,3.071-5.812,6.228-5.812s6.243,2.644,6.243,5.812l0.019,11.73H60.93l10.946,17.2,10.945-17.2H76.563l0.02-11s0.033-3.276-.116-4.055A13.349,13.349,0,0,0,63.4,17.193H58.452A13.256,13.256,0,0,0,45.569,27.411a19.487,19.487,0,0,0-.245,2.771L45.308,82.814h9.367Z",
        ],
        [
            "TURN_LEFT1",
            "M45.3,82.806V61.058A3.265,3.265,0,0,0,42.025,57.8H36.077A3.265,3.265,0,0,0,32.8,61.058l0.009,2.994h6.258l-10.946,17.2L17.18,64.052h6.258l-0.02-5.458A10.3,10.3,0,0,1,33.594,48.448H44.531A10.391,10.391,0,0,1,54.688,58.594V82.806H45.3Z",
        ],
        [
            "TURN_LEFT",
            "M45.325,82.814L45.3,31.228c0-3.168-3.071-5.812-6.228-5.812s-6.243,2.644-6.243,5.812l-0.019,11.73h6.258l-10.946,17.2L17.18,42.958h6.258l-0.02-11s-0.033-3.276.116-4.055A13.349,13.349,0,0,1,36.6,17.193h4.952A13.256,13.256,0,0,1,54.431,27.411a19.487,19.487,0,0,1,.245,2.771l0.016,52.632H45.325Z",
        ],
    ]),
};
export default Arrow;
